import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { HashRouter, Routes, Route } from 'react-router-dom';

import Home from './assets/module/home/Home';
import Layout from './assets/common/Layout';
import MouseShadow from './assets/mouseshadow/MouseShadow';
import About from './assets/module/home/About';
import Resume from './assets/module/resume/Resume';
import Achievement from './assets/module/Achievements/Achievement';

function App() {

  return (
    <>
      <MouseShadow />
    <div className="App-bg min-vh-100 d-flex flex-column">
      <HashRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home/>} />
            <Route path="home" element={<Home/>} />
            <Route path="about" element={<About/>} />
            <Route path="resume" element={<Resume/>} />
            <Route path="achievements" element={<Achievement/>} />
          </Route>
        </Routes>
      </HashRouter>
    </div>
    </>
);
}

export default App;
